import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ZapIcon } from 'lucide-react';
export function OfferSection() {
  const scrollToForm = () => {
    const el = document.getElementById('contact-form');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-[#0D0D0D] relative overflow-hidden" data-id="element-215">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#50C878]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-216"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-4xl mx-auto bg-gradient-to-b from-[#111111] to-[#0A0A0A] rounded-3xl p-8 md:p-16 text-center border border-[#50C878]/30 shadow-[0_0_40px_rgba(80,200,120,0.15)]" data-id="element-218">
          <div className="inline-flex items-center gap-2 bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] px-4 py-2 rounded-full text-sm font-bold mb-8 shadow-[0_0_15px_rgba(255,215,0,0.2)]" data-id="element-219">
            <ZapIcon className="w-4 h-4 fill-[#FFD700]" data-id="element-220" />
            PRESCRIPCIÓN FINAL
          </div>

          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-221">
            O tienes un sistema de adquisición o tienes un{' '}
            <span className="text-[#FFD700] drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-222">
              hobby costoso.
            </span>
          </h2>

          <p className="text-lg md:text-xl text-[#C0C0C0] mb-10 max-w-2xl mx-auto" data-id="element-223">
            Doctor Ecommerce solo acepta{' '}
            <span className="text-white font-bold" data-id="element-224">
              UN paciente de HVAC por zona
            </span>{' '}
            para evitar contagio entre competidores.
          </p>

          <div className="flex flex-col items-center" data-id="element-225">
            <motion.button onClick={scrollToForm} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto bg-[#FFD700] text-black font-black text-lg md:text-xl px-8 py-5 rounded-xl neon-glow transition-all duration-300 flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-226">
              PRESCRIPCIÓN: OBTENER MI DIAGNÓSTICO GRATIS
              <ArrowRightIcon className="w-6 h-6" data-id="element-227" />
            </motion.button>

            <div className="mt-8 flex items-center gap-2 bg-red-500/10 border border-red-500/20 px-4 py-2 rounded-full" data-id="element-228">
              <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-229"></span>
              <p className="text-sm text-white font-medium" data-id="element-230">
                Disponibilidad en [Ciudad] confirmada:{' '}
                <span className="text-red-400 font-bold" data-id="element-231">
                  Solo 1 cupo restante.
                </span>
              </p>
            </div>

            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="mt-6 text-[#50C878] hover:text-white underline font-bold transition-colors" data-id="element-232">
              O agenda directamente en nuestro calendario aquí →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}